export const TABLE_SET_VISIBLE_COLUMNS = 'TABLE_SET_VISIBLE_COLUMNS';
export const TABLE_SET_COLUMNS = 'TABLE_SET_COLUMNS';
export const TABLE_SET_TABLE_CONFIG = 'TABLE_SET_TABLE_CONFIG';
export const TABLE_SET_COLUMN_ORDER = 'TABLE_SET_COLUMN_ORDER';
export const TABLE_SET_DESCRIPTORS = 'TABLE_SET_DESCRIPTORS';
